export default __webpack_public_path__ + "static/media/SwitchOver.ad5d2b9a.png";